import { render, staticRenderFns } from "./SocialWarp.vue?vue&type=template&id=933de1ac&scoped=true"
import script from "./SocialWarp.vue?vue&type=script&lang=js"
export * from "./SocialWarp.vue?vue&type=script&lang=js"
import style0 from "./SocialWarp.vue?vue&type=style&index=0&id=933de1ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933de1ac",
  null
  
)

export default component.exports